import React from "react";
import { Link } from "react-router-dom";
import Reveal from "./Reveal";
import { HOME_PAGE } from "@/constants/testIds";

export default function DarkCTA({
  eyebrow = "Engage",
  heading = "If you are building something serious.",
  body,
  ctaLabel = "Work with Rakia",
  ctaTo = "/advisory",
  secondaryLabel,
  secondaryTo,
  testid = HOME_PAGE.closingCta,
}) {
  return (
    <section
      className="rk-section"
      style={{
        backgroundColor: "var(--rk-dark)",
        color: "var(--rk-cream)",
      }}
    >
      <div className="rk-container-text">
        <Reveal>
          <div className="rk-eyebrow" style={{ color: "rgba(250,247,242,0.6)" }}>
            {eyebrow}
          </div>
        </Reveal>
        <Reveal delay={0.05}>
          <h2
            className="rk-heading-section mt-5"
            style={{ color: "var(--rk-cream)" }}
          >
            {heading}
          </h2>
        </Reveal>
        {body && (
          <Reveal delay={0.1}>
            <p
              className="mt-7"
              style={{
                color: "rgba(250,247,242,0.85)",
                fontSize: "clamp(17px, 1.3vw, 20px)",
                lineHeight: 1.6,
                maxWidth: 640,
              }}
            >
              {body}
            </p>
          </Reveal>
        )}
        <Reveal delay={0.15}>
          <div className="mt-10 flex flex-wrap gap-4">
            <Link
              to={ctaTo}
              data-testid={testid}
              className="rk-btn-primary rk-btn-primary-on-dark"
            >
              {ctaLabel}
            </Link>
            {secondaryLabel && (
              <Link to={secondaryTo} className="rk-btn-outline rk-btn-outline-on-dark">
                {secondaryLabel}
              </Link>
            )}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
